import { SecurityDepositTableQuery } from 'src/app/shared/shared.model';
import {
  ProductTypeCode,
} from '../../common/models/application-general.model';
import { ResidentReference } from '../../residents/models/residents.model';
import { ApplicationDeclineTypeCode } from '../../applications/models/applications.model';

export class Claim {
  id?: string;
  resident?: ResidentReference;
  amount?: number;
  approvedAmount?: number;
  productTypeCode?: ProductTypeCode;
  statusCode?: ClaimStatusCode;
  declineTypeCode?: ApplicationDeclineTypeCode;
  isManagementAvailable?: boolean;
  createTimeUtc?: Date;
  updateTimeUtc?: Date;
}

export class ClaimsQuery extends SecurityDepositTableQuery<ClaimsQueryParameter> {
  statusCodes?: ClaimStatusCode[];
  search?: string;
}

export enum ClaimsQueryParameter {
  propertyManagerName = 1,
  amount = 2,
  status = 3,
  сreateTimeUtc = 4,
  updateTimeUtc = 5,
  shortId = 6
}

export enum ClaimStatusCode {
  submitted = 1,
  informationRequested = 2,
  pendingPayment = 3,
  partiallyApproved = 4,
  approved = 5,
  declined = 6,
  paidOut = 7,
  deleted = 8,
  archived = 9,
  underReview = 10
}

export class ClaimBalances {
  totalPaidOutBalance!: number;
  totalCount!: number;
  pendingCount!: number;
  approvedCount!: number;
  paidOutCount!: number;
  declinedCount!: number;
}
